<table-datatable class="user-roles-table" [datatableConfig]="datatableConfig()" [data]="shares()">
</table-datatable>
